import Vue from "vue";
import lightboxVue from "./Lightbox.vue";

const LightboxConstructor = Vue.extend(lightboxVue);

let instance;

const initInstance = () => {
  instance = new LightboxConstructor({
    el: document.createElement("div")
  });
  document.body.appendChild(instance.$el);
};

const showLightbox = (options) => {
  if (!instance) {
    initInstance();
  }
  console.log('showLightbox options', options);
  document.body.appendChild(instance.$el);
  const wrapper = document.querySelector('.app-wrapper');
  if (wrapper) wrapper.classList.add('has-popup');
  instance.options = options;
  Vue.nextTick(() => {
    instance.active = true;
    Vue.nextTick(() => {
      instance.initShow();
      setTimeout( () => { instance.visible = true; }, 50);
    });
  });
};

const Lightbox = function(options) {
  if (Vue.prototype.$isServer) return;
  showLightbox(options);
};

Lightbox.show = options => {
  return Lightbox(options);
};

Lightbox.close = () => {
    instance.visible = false;
      setTimeout(() => {
        instance.active = false;
      }, 300);
  const wrapper = document.querySelector('.app-wrapper');
  if (wrapper) wrapper.classList.remove('has-popup');
};

export default Lightbox;
export { Lightbox };